import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    green: {
      main: "#5DC48D",
    },

    appleBlack: {
      main: "#161618",
    },
    orange: {
      main: "#e36048",
    },
    yellow: {
      main: "#F59E0B",
    },
    white: {
      main: "#fefefe",
    },
  },
  typography: {
    fontFamily: [
      "satoshi",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default theme;
